import React from 'react';
import styles from './SimpleHeader.module.scss';

export const SimpleHeader = ({ displayName }) => {
  return (
    <div className={styles.header}>
      <span className={styles.header__title}>{displayName}</span>
    </div>
  );
};
